import { render, staticRenderFns } from "./NumericalIntegration.vue?vue&type=template&id=dc05619c&scoped=true&"
import script from "./NumericalIntegration.vue?vue&type=script&lang=js&"
export * from "./NumericalIntegration.vue?vue&type=script&lang=js&"
import style0 from "./NumericalIntegration.vue?vue&type=style&index=0&id=dc05619c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc05619c",
  null
  
)

export default component.exports